module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/hospital_list/img_noimage_doctor-1882b0e3de88a0548f33aabe3c3b569e.png";